export function resolveChartingCapabilities({ features = {}, user = null } = {}) {
    const isAuthenticatedOnlyUser = Boolean(user?.is_only_authenticated_user);
    const restrictedRole = Boolean(features?.is_restricted_charting_user);
    const hasActivePlan = Boolean(features?.has_active_role);
    const isPremiumPlan = Boolean(features?.is_platinum_user || features?.is_gold_user);
    const permissions = features?.permissions || {};

    return {
        hasActivePlan,
        isAuthenticatedOnlyUser,
        restrictedRole,
        tierLabel: (() => {
            if (isAuthenticatedOnlyUser) {
                return 'Solo autenticado';
            }

            if (features?.is_platinum_user) {
                return 'Platinum';
            }

            if (features?.is_gold_user) {
                return 'Gold';
            }

            if (features?.is_silver_user) {
                return 'Silver';
            }

            if (features?.is_bronze_user) {
                return 'Bronze';
            }

            if (features?.is_basic_user) {
                return 'Basic';
            }

            if (features?.is_pre_eureker_user) {
                return 'Pre-Eureker';
            }

            return hasActivePlan ? 'Activo' : 'Sin plan';
        })(),
        canUseFilters: hasActivePlan && !isAuthenticatedOnlyUser,
        canUseFavorites: !isAuthenticatedOnlyUser && !restrictedRole,
        canManageFavoriteFolders: !isAuthenticatedOnlyUser && !restrictedRole,
        canUseSavedSearches: !isAuthenticatedOnlyUser && !restrictedRole,
        canManageSavedSearches: !isAuthenticatedOnlyUser && !restrictedRole,
        canUseDescriptionSearch: !isAuthenticatedOnlyUser && !restrictedRole,
        canAccessPlatinumSource: !isAuthenticatedOnlyUser && !restrictedRole,
        canViewAdvancedInsights: !isAuthenticatedOnlyUser && !restrictedRole,
        canViewBasicInsights: !isAuthenticatedOnlyUser,
        canUseFundamental: !isAuthenticatedOnlyUser && Boolean(permissions?.fundamental_analisis),
        canUseDescriptionPanel: !isAuthenticatedOnlyUser && Boolean(permissions?.description_value),
        canUseAlerts: !isAuthenticatedOnlyUser && Number(permissions?.simultaneous_active_alerts || 0) > 0,
        canUseStockRegistry: !isAuthenticatedOnlyUser && Boolean(permissions?.stock_registry),
        canUseIndexCreator: !isAuthenticatedOnlyUser && Boolean(permissions?.index_creator),
        canUseBrokerConnection: !isAuthenticatedOnlyUser && Boolean(permissions?.broker_connection),
        canReportErrors: !isAuthenticatedOnlyUser,
        canSeeCompatibilityScore: !isAuthenticatedOnlyUser,
        canCreateForumThread: Boolean(user?.is_admin_user || user?.is_forum_writer_user),
        highlightPremiumData: isPremiumPlan
    };
}
